'use client';

import { replaceTokensInString } from '@cat-ecom/common/utils/stringUtils';

import { useTranslations } from 'next-intl';
import { WithCutoffTime } from './withCutoffTime';
interface CutoffTimeProps {
  cutoffTime: string;
  timezone: string;
}
const CutoffTime = ({ cutoffTime, timezone }: CutoffTimeProps) => {
  const t = useTranslations();
  const getCutoffTime = () => {
    const { remainingTime } = WithCutoffTime(cutoffTime, timezone);
    const { hours, minutes } = remainingTime || {};
    let tokenString = '';
    if ((hours || 0) + (minutes || 0) > 0 && hours < 12) {
      tokenString = replaceTokensInString(
        t('PDP_PICK_UP_ORDER_BY', {
          0: hours < 0 ? 0 : hours,
          1: minutes < 0 ? 0 : minutes
        })
      );
    }
    return <span>{tokenString}</span>;
  };
  return getCutoffTime();
};

export default CutoffTime;
